import { IElementProps } from '../../../types/interfaces'
import { ParseHtml } from '../../common/ParseHtml/ParseHtml'

const TextLabel = (props: IElementProps) => {
  return <>{props.visible && <label>{props.label ? <ParseHtml html={props.label} /> : '-'}</label>}</>
}
export default TextLabel
